import React, { useCallback } from "react";
import { Dimensions, View } from "react-native";
import { Box, MainButton, MainText, MainTitle } from "../../components/common";
import { connect } from "react-redux";
import Modal from "react-native-modal";
import i18n from "@microdoing/shared/i18n";
import LottieTeam from "./LottieTeam";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "react-native-responsive-screen";
import FastImage from "react-native-fast-image";
import { clearTeamNotifications } from "@microdoing/shared/services/notification/actions";
import EmptyPicture from "app/components/common/EmptyPicture";
import theme from "app/Theme/Theme";
import normalize from "app/utils/normalize";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";

const { width } = Dimensions.get("screen");

const AVATAR_SIZE = isWebDesktop ? normalize(65) : normalize(50);
const MODAL_MAX_WIDTH = isWebDesktop ? 450 : width * 0.9;

const NewTeamModal = ({
  isVisible = false,
  userId = "",
  team = [],
  triggerModal = () => {},
  title = "",
  multipleText = "",
  text = "",
}) => {
  const chunkTeams = useCallback(() => {
    var results = [...team.users];

    results = results.splice(0, results.length <= 5 ? 5 : 3);
    return results;
  }, [team.users, team?.users?.length]);

  const displayTeamMembers = () => {
    return (
      <View style={styles.memberTeam}>
        {chunkTeams().map((el, i) => {
          return (
            <View style={styles.avatarView} key={i}>
              {!!el.picture ? (
                <FastImage
                  resizeMode="cover"
                  source={{ uri: el.picture }}
                  style={styles.avatar}
                />
              ) : (
                <EmptyPicture
                  firstName={el.name}
                  size={normalize(35)}
                  stylePicture={styles.avatar}
                  variant="l8-bold"
                />
              )}
              <MainText
                variant="l2-medium"
                marginTop="xxs"
                textAlign="center"
                color="neutral.500"
                numberOfLines={1}
              >
                {el.name?.split(" ")?.[0]}
              </MainText>
            </View>
          );
        })}
        {team.users.length > 5 && (
          <EmptyPicture
            stylePicture={{
              zIndex: 4,
            }}
            key={1}
            size={normalize(35)}
            hasPlusSign
            firstName={
              "+" + (team?.users?.length - chunkTeams().length).toString()
            }
            variant="l8-bold"
          />
        )}
      </View>
    );
  };

  const onQuit = () => {
    clearTeamNotifications();
    triggerModal();
  };

  return (
    <Modal
      backdropTransitionOutTiming={0}
      isVisible={isVisible}
      keyboardShouldPersistTaps
      avoidKeyboard
      useNativeDriver
      onBackdropPress={onQuit}
    >
      <View style={styles.modal}>
        <View style={styles.topView}>
          <LottieTeam />
        </View>
        <Box width="100%" marginBottom={isWebDesktop ? "s" : "null"}>
          <MainTitle textAlign="center" variant="l7-bold">
            {title}
          </MainTitle>
          <Box
            marginTop={isWebDesktop ? "l" : "sm"}
            marginBottom={isWebDesktop ? "s" : "s"}
            flexDirection="row"
            justifyContent="center"
            width="100%"
          >
            {displayTeamMembers()}
          </Box>
          {multipleText.map((el, i) => (
            <MainText
              marginTop={isWebDesktop ? "s" : "null"}
              color="neutral.500"
              textAlign="center"
              key={i}
            >
              {el}
            </MainText>
          ))}
          {!!text && (
            <MainText
              variant="l2-medium"
              marginTop={isWebDesktop ? "m" : "s"}
              color="neutral.500"
              textAlign="center"
            >
              {text}
            </MainText>
          )}
        </Box>
        <MainButton text={i18n.t("ok")} onPress={onQuit} />
      </View>
    </Modal>
  );
};

const styles = {
  topView: {
    alignItems: "center",
    justifyContent: "center",
  },
  modal: {
    alignSelf: "center",
    backgroundColor: theme.colors["neutral.white"],
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 8,
    paddingVertical: theme.spacing.s,
    paddingHorizontal: isWebDesktop ? theme.spacing.xl : theme.spacing.m,
    maxWidth: MODAL_MAX_WIDTH,
  },
  titleView: {
    marginTop: 5,
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
  avatar: {
    width: AVATAR_SIZE,
    height: AVATAR_SIZE,
    borderRadius: AVATAR_SIZE / 2,
  },
  avatarView: {
    marginRight: 5,
    marginLeft: 5,
    flexDirection: "column",
  },
  name: {
    marginTop: 5,
    maxWidth: wp("14%") + 6,
    fontSize: wp("3.5%"),
    color: theme.colors["neutral.900"],
    textAlign: "center",
  },
  allAvatars: {
    marginTop: isWebDesktop ? theme.spacing.m : theme.spacing.s,
    flexDirection: "row",
    justifyContent: "center",
    width: "100%",
  },
  memberTeam: {
    display: "flex",
    flexDirection: "row",
  },
};

const mapStateToProps = state => {
  return {};
};

export default connect(mapStateToProps, {
  clearTeamNotifications,
})(NewTeamModal);
